import { localObjectStorage } from './localstorage';

// 無操作タイムアウト（ミリ秒）。セキュリティ要件: 無操作1時間でログアウト。
export const INACTIVITY_TIMEOUT_MS = 60 * 60 * 1000;

const LAST_ACTIVITY_KEY = 'last_activity_at';

// 最終操作からの経過が timeout を「超えた」場合に true（ちょうど timeout は含まない）。
// lastActivityAt が未設定（null）なら判定対象外として false を返す。
export const isInactive = (lastActivityAt, now, timeoutMs = INACTIVITY_TIMEOUT_MS) => (
  lastActivityAt != null && now - lastActivityAt > timeoutMs
);

export const recordActivity = (now = Date.now()) => {
  localObjectStorage.store(LAST_ACTIVITY_KEY, now);
};

export const readLastActivity = () => localObjectStorage.load(LAST_ACTIVITY_KEY);

export const clearLastActivity = () => {
  localObjectStorage.remove(LAST_ACTIVITY_KEY);
};
